export default __webpack_public_path__ + "588c60836eace74637d0c83ea2036c01.png";